// extracted by mini-css-extract-plugin
export default {"deductions-report-header":"NetPayReport_deductions-report-header__B1vXp"};